// extracted by mini-css-extract-plugin
export default {"container":"fitment-page-banner__container___3Hfnr","vehicle-divider":"fitment-page-banner__vehicle-divider___2TVbP","fitment-banner":"fitment-page-banner__fitment-banner___1BxJ8"};